import React from 'react';
import { Animation, Icon } from '@common/components';
import { Colors } from 'works/legacy/lib/style-helper';

type Props = {
  isHorizontalCollapsed: boolean;
  onHorizontalCollapse: () => void;
};

export function VerticalMenuFooter({
  isHorizontalCollapsed,
  onHorizontalCollapse,
}: Props) {
  return (
    <>
      <button
        onClick={onHorizontalCollapse}
        className="wk-vertical-menu-collapse-button"
        data-testid="wk-vertical-menu-collapse-button"
      >
        <Animation kind="rotate-right" active={isHorizontalCollapsed}>
          <Icon icon="arrowLeft" kind="regular" />
        </Animation>
      </button>
      <style jsx>{`
        .wk-vertical-menu-collapse-button {
          width: 100%;
          height: 40px;
          border: none;
          cursor: pointer;
          text-align: right;
          padding-right: 20px;
          padding-top: 6px;
          background-color: ${Colors.white};
        }
        .wk-vertical-menu-collapse-button:hover {
          background-color: ${Colors.elmHyperlight};
        }
        .wk-vertical-menu-collapse-button :global(.wk-animation) {
          height: 18px;
        }
      `}</style>
    </>
  );
}
